<script>
import { resolveJSON } from '@/helperfunctions'

export default {
  name: 'CountriesMixin',
  computed: {
    countries () {
      return this.$root.countries
    }
  },
  created: function() {
    this.fetchCountries()
  },
  methods: {
    fetchCountries() {
      if (this.$root.countries.length > 1 || this.$root.fetchingCountries) {
        return
      }
      this.$root.fetchingCountries = true
      fetch('/api/countries/')
        .then(resolveJSON)
        .then(json => {
          this.$root.countries = json.countries.sort((a, b) => a[1] < b[1] ? -1 : 1)
        })
        .catch(error => console.error(error))
    }
  }
}
</script>
